// Voysi flamingo Waveform. Port of voysi-shell.jsx::Waveform.
// Pure CSS animation driven by the global `voysiBar` keyframe (defined in
// index.css). Each bar offsets its duration + delay for an organic shimmer.

interface WaveformProps {
  bars?: number
  height?: number
  /** flamingo gradient by default; "success" swaps to the green variant. */
  color?: 'primary' | 'success'
  className?: string
}

export function Waveform({ bars = 18, height = 28, color = 'primary', className }: WaveformProps) {
  const gradient =
    color === 'primary'
      ? 'linear-gradient(to bottom,#FF3D84,#FF7FAC)'
      : 'linear-gradient(to bottom,#1DB954,#7CD992)'
  return (
    <div
      className={'flex items-center gap-[3px]' + (className ? ` ${className}` : '')}
      style={{ height }}
    >
      {Array.from({ length: bars }).map((_, i) => (
        <div
          key={i}
          className="rounded-[2px]"
          style={{
            width: 3,
            flex: 'none',
            height: '100%',
            background: gradient,
            transformOrigin: 'center',
            animation: `voysiBar 0.${5 + (i * 7) % 5}s ease-in-out infinite alternate`,
            animationDelay: `${(i % 6) * 0.07}s`,
          }}
        />
      ))}
    </div>
  )
}
